<div id="table_violations" class="tablewrap resizetable tabpage hidden">
    <div class="table tableinfo">
        <table fixedcols="[0]" id="trackviolationstable">
          <tr>
            <th><input type="checkbox" /></th>
            <th class="datetime_column">{{'Time'|translate }}</th>
            <th class="time_column">{{'Duration'|translate }}</th>
            <th class="object_column">{{'Object'|translate }}</th>
            <th>{{'Event'|translate }}</th>
            <th>{{'Value'|translate }}</th>
            <th>{{'Penalty'|translate }}</th>
            <th>{{'Address'|translate }}</th>
          </tr>
        </table>
    </div>
    <app-pagination [viewmode]="'print excel'" [printElementID]="'trackviolationstable'"></app-pagination>
</div>
